import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { Storage } from 'aws-amplify';
// import JSZip from 'jszip';
import DownloadCommandIcon from '@/component/ticketKnowledge/icons/DownloadCommandIcon';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import Constant from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
export default function DownloadCommand() {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const [isDisabled, setIsDisabled] = useState(false);

    const onClickDownloadCommand = async (path) => {
        const pathSdImport = path;
        const pathReadme = Constant.COMMAND_CSV.README_PATH;

        try {
            setIsDisabled(true);
            // const zip = new JSZip();
            //blob sdimport
            let sdimportUrl = await Storage.get(pathSdImport, { level: 'public' });
            const sdimportResponse = await fetch(sdimportUrl);
            const sdimportBlob = await sdimportResponse.blob();
            // zip.file('sdeskcommand/sdimport.sh', sdimportBlob);

            //blob readme
            // let readmeUrl = await Storage.get(pathReadme, { level: 'public' });
            // const readmeResponse = await fetch(readmeUrl);
            // const readmeBlob = await readmeResponse.blob();
            // zip.file('sdeskcommand/readme.md', readmeBlob);

            // create file zip và download
            // const content = await zip.generateAsync({ type: 'blob' });
            // const downloadUrl = URL.createObjectURL(content);

            const sdimportDownloadUrl = window.URL.createObjectURL(new Blob([sdimportBlob]));
            const downloadLink = document.createElement('a');

            downloadLink.href = sdimportDownloadUrl;
            const attr = path.split('/')[1];
            downloadLink.setAttribute('download', attr);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            setIsDisabled(false);
        } catch (error) {
            setIsDisabled(false);
            console.error('Error downloading files', error);
        }
    };

    return (
        <div className="mapping-wrapper wrapper-download-command">
            <Button
                onClick={() => onClickDownloadCommand(Constant.COMMAND_CSV.LINUX_PATH)}
                disabled={isDisabled}
                className="btn-hg32 btn-light"
                startIcon={<DownloadCommandIcon />}
            >
                <OverFlowTooltipWithTabsMui
                    value={trI18n('LABEL-BUTTON-DOWLOAD-LINUX-COMMAND')}
                />
            </Button>
            <Button
                onClick={() => onClickDownloadCommand(Constant.COMMAND_CSV.WINDOWS_PATH)}
                disabled={isDisabled}
                className="btn-hg32 btn-light"
                startIcon={<DownloadCommandIcon />}
            >
                <OverFlowTooltipWithTabsMui
                    value={trI18n('LABEL-BUTTON-DOWNLOAD-WINDOWS-COMMAND')}
                />
            </Button>
        </div>
    );
}
